import { Box, Container, Typography, Stack, Divider, Skeleton } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import PageHero from '../components/common/PageHero';
import AnimatedSection from '../components/common/AnimatedSection';
import { useLegal } from '../hooks/usePublicApi';
import { impressum as staticImpressum } from '../data/legal';

export default function Impressum() {
  const { legal: apiData, loading } = useLegal('impressum');
  const impressum = loading ? null : (apiData || staticImpressum);

  return (
    <>
      <Helmet>
        <title>Impressum — Süd Ausbau GmbH</title>
        <meta name="description" content="Impressum der Süd Ausbau GmbH — Angaben gemäß § 5 TMG." />
        <meta name="robots" content="noindex, nofollow" />
        <link rel="canonical" href="https://sued-ausbau.de/impressum" />
      </Helmet>

      <PageHero title="Impressum" />

      <Box sx={{ py: { xs: 6, md: 10 } }}>
        <Container maxWidth="md">
          {!impressum ? (
            <Stack spacing={3}>
              {[200, 120, 160, 140, 180].map((w, i) => (
                <Skeleton key={i} variant="rectangular" height={w} sx={{ borderRadius: 2 }} />
              ))}
            </Stack>
          ) : (
          <AnimatedSection>
            <Stack spacing={4}>
              <Box>
                <Typography variant="h4" sx={{ mb: 2 }}>Angaben gemäß § 5 TMG</Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  {impressum.company?.name || impressum.company}
                </Typography>
                <Typography variant="body1">{impressum.address?.street}</Typography>
                <Typography variant="body1">{impressum.address?.zip} {impressum.address?.city}</Typography>
              </Box>

              <Divider />

              <Box>
                <Typography variant="h5" sx={{ mb: 2 }}>Kontakt</Typography>
                {impressum.contact?.phone && <Typography variant="body1">Telefon: {impressum.contact.phone}</Typography>}
                {impressum.contact?.fax && <Typography variant="body1">Fax: {impressum.contact.fax}</Typography>}
                {impressum.contact?.email && <Typography variant="body1">E-Mail: {impressum.contact.email}</Typography>}
                {impressum.contact?.website && <Typography variant="body1">Web: {impressum.contact.website}</Typography>}
              </Box>

              <Divider />

              <Box>
                <Typography variant="h5" sx={{ mb: 2 }}>Vertreten durch</Typography>
                {impressum.company?.ceo && (
                  <Typography variant="body1">Geschäftsführer: {impressum.company.ceo}</Typography>
                )}
                {impressum.company?.representative && (
                  <Typography variant="body1">Vertretungsberechtigter: {impressum.company.representative}</Typography>
                )}
              </Box>

              <Box>
                <Typography variant="h5" sx={{ mb: 2 }}>Registereintrag</Typography>
                {impressum.legal?.court && <Typography variant="body1">Registergericht: {impressum.legal.court}</Typography>}
                {impressum.legal?.registrationNumber && <Typography variant="body1">Registernummer: {impressum.legal.registrationNumber}</Typography>}
                {impressum.legal?.hrb && <Typography variant="body1">Registernummer: {impressum.legal.hrb}</Typography>}
                {impressum.legal?.vatId && <Typography variant="body1">Umsatzsteuer-ID: {impressum.legal.vatId}</Typography>}
                {impressum.legal?.taxNumber && <Typography variant="body1">Steuernummer: {impressum.legal.taxNumber}</Typography>}
              </Box>

              <Divider />

              <Box>
                <Typography variant="h5" sx={{ mb: 2 }}>Haftung für Inhalte</Typography>
                <Typography variant="body1" color="text.secondary" sx={{ whiteSpace: 'pre-line' }}>
                  {impressum.disclaimer}
                </Typography>
              </Box>

              <Box>
                <Typography variant="h5" sx={{ mb: 2 }}>Haftung für Links</Typography>
                <Typography variant="body1" color="text.secondary" sx={{ whiteSpace: 'pre-line' }}>
                  {impressum.linkDisclaimer}
                </Typography>
              </Box>

              <Box>
                <Typography variant="h5" sx={{ mb: 2 }}>Urheberrecht</Typography>
                <Typography variant="body1" color="text.secondary" sx={{ whiteSpace: 'pre-line' }}>
                  {impressum.copyright}
                </Typography>
              </Box>
            </Stack>
          </AnimatedSection>
          )}
        </Container>
      </Box>
    </>
  );
}
